export default __webpack_public_path__ + "static/media/opportunity.20d7e9c0.svg";